import { createReducer } from '../../../helpers/reducer';
import { DOCUMENT_MAX_SIZE } from '../../../helpers/fileValidation';
import actionTypes from './actionTypes';
import { IDataUploadsState, ILoadDataSuccessPayload, ILoadFormDataSuccessPayload, IUploadType } from './types';

const initState: IDataUploadsState = {
  uploads: [],
  loading: false,
  total: 0,
  filteredTotal: 0,
  filters: [],
  sortableColumns: [],
  uploadTypes: [],
  uploadTypesLoading: false,
  maxFileSizeBytes: DOCUMENT_MAX_SIZE.value,

  isModalVisible: false,
  selectedUploadType: null,
  selectedFile: null,
  isUploading: false,
  uploadError: false,
};

function onLoadData(state: IDataUploadsState) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadDataSuccess(state: IDataUploadsState, { payload }: { payload: ILoadDataSuccessPayload }) {
  const { records, totalCount, filteredCount, filters, sortableColumns } = payload;

  return {
    ...state,
    uploads: records,
    filters,
    sortableColumns: sortableColumns || state.sortableColumns,
    total: totalCount,
    filteredTotal: filteredCount,
    loading: false,
  };
}

function onLoadDataError(state: IDataUploadsState) {
  return {
    ...state,
    loading: false,
  };
}

function onLoadFormData(state: IDataUploadsState) {
  return {
    ...state,
    uploadTypesLoading: true,
  };
}

function onLoadFormDataSuccess(state: IDataUploadsState, { payload }: { payload: ILoadFormDataSuccessPayload }) {
  return {
    ...state,
    uploadTypes: payload.uploadTypes,
    maxFileSizeBytes: payload.maxFileSizeBytes || state.maxFileSizeBytes,
    uploadTypesLoading: false,
  };
}

function onLoadFormDataError(state: IDataUploadsState) {
  return {
    ...state,
    uploadTypesLoading: false,
  };
}

function onSetModalVisible(state: IDataUploadsState, { payload }: { payload: boolean }) {
  return {
    ...state,
    isModalVisible: payload,
  };
}

function onSetUploadType(state: IDataUploadsState, { payload }: { payload: IUploadType | null }) {
  return {
    ...state,
    selectedUploadType: payload,
  };
}

function onSetFile(state: IDataUploadsState, { payload }: { payload: File | null }) {
  return {
    ...state,
    selectedFile: payload,
    uploadError: false,
  };
}

function onUploadFile(state: IDataUploadsState) {
  return {
    ...state,
    isUploading: true,
    uploadError: false,
  };
}

function onUploadFileSuccess(state: IDataUploadsState) {
  return {
    ...state,
    isUploading: false,
  };
}

function onUploadFileError(state: IDataUploadsState) {
  return {
    ...state,
    isUploading: false,
    uploadError: true,
  };
}

function onClearModal(state: IDataUploadsState) {
  return {
    ...state,
    isModalVisible: false,
    selectedUploadType: null,
    selectedFile: null,
    isUploading: false,
    uploadError: false,
  };
}

function onClearStore(state: IDataUploadsState) {
  return {
    ...initState,
    uploadTypes: state.uploadTypes,
    maxFileSizeBytes: state.maxFileSizeBytes,
  };
}

export default createReducer(initState, {
  [actionTypes.LOAD_DATA_REQUEST]: onLoadData,
  [actionTypes.LOAD_DATA_SUCCESS]: onLoadDataSuccess,
  [actionTypes.LOAD_DATA_ERROR]: onLoadDataError,
  [actionTypes.LOAD_FORM_DATA_REQUEST]: onLoadFormData,
  [actionTypes.LOAD_FORM_DATA_SUCCESS]: onLoadFormDataSuccess,
  [actionTypes.LOAD_FORM_DATA_ERROR]: onLoadFormDataError,
  [actionTypes.SET_MODAL_VISIBLE]: onSetModalVisible,
  [actionTypes.SET_UPLOAD_TYPE]: onSetUploadType,
  [actionTypes.SET_FILE]: onSetFile,
  [actionTypes.UPLOAD_FILE_REQUEST]: onUploadFile,
  [actionTypes.UPLOAD_FILE_SUCCESS]: onUploadFileSuccess,
  [actionTypes.UPLOAD_FILE_ERROR]: onUploadFileError,
  [actionTypes.CLEAR_MODAL]: onClearModal,
  [actionTypes.CLEAR_STORE]: onClearStore,
});
